export default __webpack_public_path__ + "locales/zh-CN/OAuth.json?hash=df6a6f7522497d1b3067c73bf945fad7";